module.exports = __webpack_public_path__ + "static/media/Южный Лес ночь.c9ad08cd.jpg";